import { useState } from "react";
import { toast } from "react-toastify";
import { Button, ModalDefault, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "../../hooks/useService";
import { formatBRL, formatCompetencia } from "../ow";

/**
 * Confirmação da aprovação de uma nota fiscal: na aba Pagamentos do contrato, no
 * detalhe do pagamento e na lista de notas fiscais.
 *
 * Props:
 * - invoice: nota como vem da API
 * - schedule: cronograma da nota, ou só { reference_month, reference_year } (usado
 *   só para a competência no texto)
 * - onClose
 * - onApproved: depois de aprovar (recarregar)
 */
export default function ApproveInvoiceModal({ invoice, schedule, onClose, onApproved }) {
  const taxInvoicesService = useService("taxInvoices");
  const [loading, setLoading] = useState(false);

  function close() {
    if (!loading) onClose();
  }

  async function confirm() {
    setLoading(true);
    try {
      const result = await taxInvoicesService.approve(invoice.id);
      if (result && !result.error) {
        toast.success("Nota fiscal aprovada!");
        setLoading(false);
        onApproved();
        return;
      }
      // Erro com { error: true } vem do sendError do service, que já mostrou o toast
      if (!result?.error) toast.error("Erro ao aprovar NF");
    } catch (err) {
      toast.error("Erro ao aprovar nota fiscal");
    }
    setLoading(false);
  }

  const competence = { month: Number(schedule.reference_month), year: Number(schedule.reference_year) };

  return (
    <ModalDefault
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $size="medium"
      $title="Aprovar nota fiscal?"
      $contentBackground="N0"
      $footer={
        <>
          <Button $text="Cancelar" $variant="outline" $noWidth $isDisabled={loading} $action={close} />
          <Button $text="Aprovar nota" $variant="primary" $noWidth $isLoading={loading} $action={confirm} />
        </>
      }>
      <Text
        $text="Nota de <strong>%s</strong>, no valor de <strong>%s</strong>. Depois de aprovada, o pagamento pode ser registrado."
        $replaces={[formatCompetencia(competence, true), formatBRL(invoice.value)]}
        $variant="paragraph_small_medium"
        $color="N700"
        $colorEmphasis="N900"
      />
    </ModalDefault>
  );
}
